module.exports = __webpack_public_path__ + "img/logo_white.09728c26.svg";